// The three things "+ Add Event" offers, and how they differ.
//
// They are different forms in MMS. Rather than three drawers, each mode says
// which sections and fields apply, because the underlying event is the same
// document either way.
//
//                     Quick-Add        Add New Event    Non-Teaching
//   attendees         one, optional    many             none
//   category          no               yes              yes
//   duration          no (default)     yes              yes
//   pricing           no (default)     yes              none
//   recurrence        all three        all three        no weekly hold
//   descriptions      no               public+private   public only
//   make-up credit    yes              yes              no
//   online booking    no               yes              no

export const EVENT_MODES = {
  quick: 'quick',
  full: 'full',
  nonTeaching: 'nonTeaching',
};

const SHAPES = {
  [EVENT_MODES.quick]: {
    title: 'Quick-Add Lesson',
    // One student, required unless "open lesson slot" is ticked — a held slot
    // with nobody in it yet is a real thing a teacher schedules.
    attendees: 'single',
    requireAttendee: true,
    category: false,
    duration: false,
    pricing: false,
    weeklyHold: true,
    publicDescription: false,
    privateDescription: false,
    makeupCredit: true,
    onlineBooking: false,
  },
  [EVENT_MODES.full]: {
    title: 'New Calendar Event',
    attendees: 'multiple',
    requireAttendee: true,
    category: true,
    duration: true,
    pricing: true,
    weeklyHold: true,
    publicDescription: true,
    privateDescription: true,
    makeupCredit: true,
    onlineBooking: true,
  },
  [EVENT_MODES.nonTeaching]: {
    title: 'New Non-Teaching Event',
    // Nothing is taught, so nobody attends and nothing is charged. Leaving
    // pricing on a non-teaching event is how a recital ends up on an invoice.
    attendees: 'none',
    requireAttendee: false,
    category: true,
    duration: true,
    pricing: false,
    weeklyHold: false,
    publicDescription: true,
    privateDescription: false,
    makeupCredit: false,
    onlineBooking: false,
  },
};

export function eventShape(mode) {
  return SHAPES[mode] || SHAPES[EVENT_MODES.full];
}

// Editing always shows everything: the event already exists and may carry values
// a narrower form cannot display, and hiding a field that holds a value is how
// it gets silently dropped on the next save.
//
// It does not require an attendee, though. A non-teaching event or an open slot
// has none by design, and demanding one to save an unrelated edit would make
// those events uneditable.
export const EDIT_SHAPE = {
  ...SHAPES[EVENT_MODES.full],
  title: 'Edit Calendar Event',
  requireAttendee: false,
};
